/**
 * Created by HDWebSoft on 11-Sep-20.
 */
$(document).ready(() => {
  let textBox = $('#description_embed');
  embedVideoReady();
  textBox.on('input propertychange', function () {
    let description = $(this).val();
    let arrLinks = description.split("http");
    $(".embed-video").remove();
    arrLinks.forEach(function (element) {
      element = "http" + element;
      element = element.replace('watch?v=', 'embed/');
      if (element.includes("https://")) {
        embedVideo(element);
      }
    });
  });
  function embedVideoReady() {
    let description = textBox.val();
    let arrLinks = [];
    if (typeof (description) !== 'undefined') {
      arrLinks = description.split("http");
    }
    arrLinks.forEach(function (element) {
      element = "http" + element;
      element = element.replace('watch?v=', 'embed/');
      if (element.includes("https://")) {
        embedVideo(element);
      }
    });
  }

  function embedVideo(element) {
    let replaced = false;
    let urlRegex = /(https?:\/\/[^\s]+)/g;
    element.replace(urlRegex, function (url) {
      let html = `<iframe class="embed-video" width="80%" height="220" src="${url}" frameborder="0" 
                             allow="autoplay; encrypted-media" allowfullscreen>
                            </iframe> 
                           `;
      let preview = $(document.createElement('div'));
      preview.html(html);
      textBox.closest('.field').append(preview)
      replaced = true;
    });
  }


  function readURL(input, $preview) {
    if (input.files && input.files[0]) {
      let reader = new FileReader();
      reader.onload = function (e) {
        $preview.attr('src', e.target.result);
      }
      reader.readAsDataURL(input.files[0]); // convert to base64 string
    }
  }

  $('.photo-preview').change(function () {
    let previewImg = $('.photo-preview-img');
    previewImg.show();
    readURL(this, previewImg);
  })
})